export default "__VITE_ASSET__DkSZnWWl__"